/**
 * src/components/hero/HeroCTAs.js
 *
 * Grupo de botones CTA del hero.
 * Props: { ctas: Array<{ label, href, variant, icon? }> }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

define('HeroCTAs', ({ ctas = [] }) => {
    const wrapper = h('div', { className: 'hero-ctas' })

    ctas.forEach(({ label, href, variant = 'primary', icon }) => {
        const isExternal = href && href.startsWith('http')
        const btn = h('a', { className: `hero-ctas__btn hero-ctas__btn--${variant}`, href, ...(isExternal ? { target: '_blank', rel: 'noopener' } : {}) })
        if (icon) btn.appendChild(h('span', { className: 'hero-ctas__icon', innerHTML: icon }))
        btn.appendChild(document.createTextNode(label))
        wrapper.appendChild(btn)
    })

    return wrapper
})
